import * as React from 'react'

import { cn } from '@/lib/utils'

interface ActionBarProps {
  children: React.ReactNode
  align?: 'start' | 'end' | 'center'
  className?: string
}

export function ActionBar({
  children,
  align = 'end',
  className,
}: ActionBarProps) {
  const alignmentClass = {
    start: 'justify-start',
    end: 'justify-end',
    center: 'justify-center',
  }[align]

  return (
    <div className={cn('flex flex-wrap gap-2', alignmentClass, className)}>
      {children}
    </div>
  )
}
